import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7963dac6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7963dac6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7963dac6')) {
      api.createRecord('7963dac6', component.options)
    } else {
      api.reload('7963dac6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7963dac6", function () {
      api.rerender('7963dac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/jsSidebar/index.vue"
export default component.exports